import appTheme from '../../theme'

const theme = {
  neonPrimary: appTheme.neonPrimary,
  neonPrimaryLight: appTheme.neonPrimaryLight,
  black: appTheme.black,
  white: appTheme.white,
  grey: appTheme.darkBorder,
  darkGrey: appTheme.field,
  red: appTheme.error,
  media: {
    tablet: '@media(min-width:768px)',
    desktop: '@media(min-width:1024px)'
  }
}

export default theme
